// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-toolbar {
  --background: transparent;
  position: absolute;
}

.product-image {
  flex: 0;
  flex-basis: calc(86 * var(--width-ratio));
}
.product-image .img_container .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  background-image: url("/assets/img/product-sample.png");
}

.product-name {
  flex: 1;
  margin-left: calc(10 * var(--width-ratio));
}

.mydivider {
  padding-top: 7px;
  padding-bottom: 7px;
}

/* 商品規格 */
.product-spec ion-select {
  width: 100%;
  border: 1px;
  border-color: var(--ion-color-primary-tint);
  border-style: solid;
  border-radius: 40px;
  text-align: center;
}
.product-spec .myselect {
  margin-left: calc(16 * var(--width-ratio));
  margin-top: calc(8 * var(--width-ratio));
}
.product-spec .myselect ::part(text) {
  color: var(--ion-color-dark-tint);
  white-space: unset;
}

/* 商品數量 */
.footer {
  box-shadow: unset;
  padding-top: calc(6 * var(--width-ratio));
  padding-bottom: calc(6 * var(--width-ratio));
}
.footer .cart .mybutton {
  --background: var(--ion-color-primary);
  width: calc(328 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/add-cart-modal/add-cart-modal.page.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,yBAAA;EACA,kBAAA;AAEF;;AACA;EACE,OAAA;EACA,yCAAA;AAEF;AACI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EACA,uDAAA;AACN;;AAIA;EACE,OAAA;EACA,0CAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;AADF;;AAIA,SAAA;AAEE;EACE,WAAA;EAEA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,kBAAA;AAJJ;AAOE;EACE,0CAAA;EACA,wCAAA;AALJ;AASI;EACE,iCAAA;EACA,kBAAA;AAPN;;AAYA,SAAA;AAOA;EACE,iBAAA;EACA,yCAAA;EACA,4CAAA;AAfF;AAkBI;EACE,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AAhBN","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.product-image {\n  flex: 0;\n  flex-basis: calc(86 * var(--width-ratio));\n\n  .img_container {\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      background-image: url(\"/assets/img/product-sample.png\");\n    }\n  }\n}\n\n.product-name {\n  flex: 1;\n  margin-left: calc(10 * var(--width-ratio));\n}\n\n.mydivider {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n/* 商品規格 */\n.product-spec {\n  ion-select {\n    width: 100%;\n\n    border: 1px;\n    border-color: var(--ion-color-primary-tint);\n    border-style: solid;\n    border-radius: 40px;\n    // height: calc(32 * var(--width-ratio));\n    text-align: center;\n  }\n\n  .myselect {\n    margin-left: calc(16 * var(--width-ratio));\n    margin-top: calc(8 * var(--width-ratio));\n    // background: rgba(162, 146, 193, 0.1);\n    // border-radius: 10px;\n\n    ::part(text) {\n      color: var(--ion-color-dark-tint);\n      white-space: unset;\n    }\n  }\n}\n\n/* 商品數量 */\n.product-quantity {\n  .number-picker {\n    // margin-left: 16px;\n  }\n}\n\n.footer {\n  box-shadow: unset;\n  padding-top: calc(6 * var(--width-ratio));\n  padding-bottom: calc(6 * var(--width-ratio));\n\n  .cart {\n    .mybutton {\n      --background: var(--ion-color-primary);\n      width: calc(328 * var(--width-ratio));\n      height: calc(42 * var(--width-ratio));\n      margin: auto;\n      --border-radius: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
